/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  capitalizeFullName,
  formatDate,
  nameValidation,
} from "../../helpers/commonHelper";
import { useEffect, useState } from "react";

import Header from "../Layout/Header";
import PdfViewer from "./PdfViewer";
import SignaturePad from "../Forms/SignaturePad";
import { useTranslation } from "react-i18next";

const AgreedForm = ({
  handleCheckboxChange1,
  handleCheckboxChange2,
  handleCheckboxChange3,
  checkbox1,
  checkbox2,
  checkbox3,
  userConsents,
  openModal,
  navigateToPayment,
  savefolioCard,
  folio,
  clearSign,
  data,
  signature,
  setSignature,
  setUrl,
  url,
  showFolio,
  gotSignature,
  onBackPress,
  signatureRequired,
  showReservationPage,
  signatureFolioManadatory,
  fixedSignatureCanvasHeight,
  fixedSignatureCanvasWidth,
}) => {
  const [containerHeight, setContainerHeight] = useState(0);
  const { t } = useTranslation();
  const showFolioConsent1 = userConsents.some(
    (c) => c.consentCode === "CheckoutConsent1"
  );
  const isFolioConsent1Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "CheckoutConsent1" && consent.isMandatory
  );
  const showFolioConsent2 = userConsents.some(
    (c) => c.consentCode === "CheckoutConsent2"
  );
  const isFolioConsent2Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "CheckoutConsent2" && consent.isMandatory
  );
  const showFolioConsent3 = userConsents.some(
    (c) => c.consentCode === "CheckoutConsent3"
  );
  const isFolioConsent3Mandatory = userConsents.some(
    (consent) =>
      consent.consentCode === "CheckoutConsent3" && consent.isMandatory
  );
  useEffect(() => {
    const calculateContainerHeight = () => {
      const footerHeight = document.querySelector("footer").clientHeight;
      const viewportHeight = window.innerHeight;
      setContainerHeight(`calc(${viewportHeight}px - ${footerHeight}px)`);
    };

    calculateContainerHeight();
    window.addEventListener("resize", calculateContainerHeight);

    return () => {
      window.removeEventListener("resize", calculateContainerHeight);
    };
  }, []);

  return (
    <div>
      <main>
        <div
          className="main-content"
          // style={{ height: containerHeight, overflowY: "auto" }}
        >
          <div className="h-100">
            <div className="d-flex justify-content-between">
              <div>
                <Header
                  onClick={onBackPress}
                  setShowModal={openModal}
                  isHome={true}
                  title={""}
                  subTitle={""}
                />
              </div>
            </div>
            <div
              className="justify-content-center"
              style={{ marginTop: "10px" }}
            >
              <div
                className={
                  showReservationPage === false && signatureRequired === false
                    ? "d-flex h-70 justify-content-center"
                    : "d-flex h-70 justify-content-center"
                }
              >
                {showFolio && (
                  <div
                    className={
                      showReservationPage === false &&
                      signatureRequired === false
                        ? "col-lg-7"
                        : "col-lg-7"
                    }
                  >
                    <PdfViewer folio={folio} />
                  </div>
                )}

                <div
                  className={
                    showReservationPage === false && signatureRequired === false
                      ? "flex"
                      : "d-flex flex-column justify-content-center col-lg-5 pd-30"
                  }
                >
                  {showReservationPage && (
                    <div>
                      <div className="info-invoice">
                        <div>
                          <h5>{t("Reservation Details")}</h5>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-4">
                            <label className="reservation-card-label">
                              {t("Confirmation")}:
                            </label>
                            <div>
                              <p>{data?.pmsConfirmationNo}</p>
                            </div>
                          </div>
                          <div className="col-4">
                            <label className="reservation-card-label">
                              {t("Guest Name")}:
                            </label>
                            <div>
                              <p>
                                {data?.firstName + " " + data?.lastName || ""}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4">
                            <label className="reservation-card-label">
                              {t("Arrival Date:")}
                            </label>
                            <div>
                              <p>{formatDate(data?.arrivalDate)}</p>
                            </div>
                          </div>
                          <div className="col-4">
                            <label className="reservation-card-label">
                              {t("Departure Date:")}
                            </label>
                            <div>
                              <p>{formatDate(data?.departureDate) || ""}</p>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <label className="reservation-card-label">
                              {t("Room Number")}:
                            </label>
                            <div>
                              <p>{Number(data?.roomNo)}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Checkboxes */}
                  <div>
                    {showFolioConsent1 && (
                      <div className="folio-accept-condition">
                        <input
                          type="checkbox"
                          className="folio-accept-check"
                          id="agreeTerms"
                          // checked={agreeTerms}
                          // onChange={() => setAgreeTerms(!agreeTerms)}
                          checked={checkbox1}
                          onChange={handleCheckboxChange1}
                        />
                        <h6>
                          <label htmlFor="agreeTerms">
                            {t("CheckoutConsent1")}
                            {isFolioConsent1Mandatory && (
                              <span className="mandatory-label">
                                ({t("Required")})
                              </span>
                            )}
                          </label>
                        </h6>
                      </div>
                    )}
                    {showFolioConsent2 && (
                      <div class="folio-accept-condition">
                        <input
                          className="folio-accept-check"
                          type="checkbox"
                          id="agreePolicy"
                          checked={checkbox2}
                          onChange={handleCheckboxChange2}
                        />
                        <h6>
                          <label htmlFor="agreePolicy">
                            {t("CheckoutConsent2")}
                            {isFolioConsent2Mandatory && (
                              <span className="mandatory-label">
                                ({t("Required")})
                              </span>
                            )}
                          </label>
                        </h6>
                      </div>
                    )}
                    {showFolioConsent3 && (
                      <div class="folio-accept-condition">
                        <input
                          className="folio-accept-check"
                          type="checkbox"
                          id="agreePolicy"
                          checked={checkbox2}
                          onChange={handleCheckboxChange3}
                        />
                        <h5>
                          <label htmlFor="agreePolicy">
                            {t("CheckoutConsent3")}
                            {isFolioConsent3Mandatory && (
                              <span className="mandatory-label">
                                ({t("Required")})
                              </span>
                            )}
                          </label>
                        </h5>
                      </div>
                    )}
                  </div>

                  {signatureRequired === true && (
                    <>
                      <div className="flex">
                        <h5
                          style={{
                            color: "var(--secondary-color)",
                            marginBottom: "40px",
                            marginTop: "50px",
                          }}
                        >
                          {t("Agree by signing here")}
                        </h5>
                        <div className="sign-wrapper">
                          <div style={{ marginRight: "10px" }}>
                            <button
                              id="btn-agreedformtest-clear"
                              onClick={clearSign}
                              className="terms-retry-btn-folio"
                            >
                              <i className="bx bx-revision"></i>
                            </button>
                          </div>
                          <SignaturePad
                            signature={signature}
                            setSignature={setSignature}
                            gotSignature={gotSignature}
                            setUrl={setUrl}
                            url={url}
                            showRetryBtn={false}
                            fixedSignatureCanvasHeight={fixedSignatureCanvasHeight}
                            fixedSignatureCanvasWidth={fixedSignatureCanvasWidth}
                          />
                        </div>
                      </div>
                      <div>
                        <button
                          id="btn-agreedformtest-proceed1"
                          disabled={signatureFolioManadatory && !url}
                          onClick={savefolioCard}
                          className="btn button-blue proceed-blue-btn"
                          style={{
                            float: "right",
                            marginTop: "50px",
                            marginLeft: "30px",
                          }}
                        >
                          {t("Proceed")}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {showReservationPage === false && signatureRequired === false && (
                <>
                  <div className="d-flex justify-content-center my-4">
                  <button
                    id="btn-agreedformtest-proceed"
                    onClick={savefolioCard}
                    disabled={
                      localStorage.getItem("blockpaymentatFolio") === "true"
                    }
                    className="btn button-blue proceed-blue-btn"
                    // style={{
                    //   float: "left",
                    //   // marginTop: "8%",
                    //   marginLeft: "47%",
                    //   marginBottom: "5%",
                    // }}
                  >
                    {t("Proceed")}
                  </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AgreedForm;
